import {Component} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {BaseGridNoCookieComponent} from 'app/core-ui/abstract/basegrid/basegridnocookie.component';
import {EventsEmitterService} from 'app/core-ui/abstract/services/emitter.service';
import {LogService} from 'app/core-ui/abstract/services/log.service';
import {SecurityService} from 'app/core-ui/abstract/services/security.service';
import {VisualsService} from 'app/core-ui/abstract/services/visuals.service';
import {forkJoin} from 'rxjs';
import {OnBoardingDocsAMLService} from './onBoardingDocsAML.service';

@Component({
  selector: 'onBoardingDocsAML-grid',
  templateUrl: './onBoardingDocsAML.component.html',
  providers: [OnBoardingDocsAMLService],
})
export class OnBoardingDocsAMLComponent extends BaseGridNoCookieComponent<OnBoardingDocsAMLService> {
  companyTypeList = [];
  getAssignedList = [];
  getRemaingList = [];
  selectedAssignedList = [];
  selectedRemaingList = [];
  docList = [];
  getRemainingParams = {};
  getAssignedParams = {};
  langId: any;
  selectedCompanyType: any;
  refernceTable: any;
  lkupTable: any;
  lkupCol: any;
  viewRole = this.securityService.isOtherStaff();

  constructor(
    public gridService: OnBoardingDocsAMLService,
    public eventsEmitterService: EventsEmitterService,
    public securityService: SecurityService,
    logger: LogService,
    visualsService: VisualsService,
    public route: ActivatedRoute,
  ) {
    super(securityService, logger, visualsService, gridService, 'repLedgerDemands');

    this.loadVisuals();
    this.docList = this.visualsService.getLkpFromStorageAsJSON(
      'LKP_REGCMP_AML_DOCUMENT_I_DOC_ID',
      true,
    );
    this.companyTypeList = this.visualsService.getLkpFromStorageAsJSON('LKP_LEGAL_FORM', true);
    this.eventsEmitterService.languageChange.subscribe({
      next: (langId) => {
        this.loadVisuals();
        this.companyTypeList = this.visualsService.getLkpFromStorageAsJSON('LKP_LEGAL_FORM', true);
        this.docList = this.visualsService.getLkpFromStorageAsJSON(
          'LKP_REGCMP_AML_DOCUMENT_I_DOC_ID',
          true,
        );
      },
    });
  }

  ngOnInit() {
    this.lkupCol = 'S_AML_TYPE';
    this.lkupTable = 'REGCMP_AML_DOCUMENT';
    this.refernceTable = 'CMP_AML_MAP';
    this.selectedCompanyType = this.companyTypeList[0].id;
    this.langId = localStorage.getItem('langId');
    this.refreshLists();
  }

  assign(id) {
    if (this.selectedRemaingList.includes(id)) {
      this.selectedRemaingList.splice(this.selectedRemaingList.indexOf(id), 1);
    } else {
      this.selectedRemaingList.push(id);
    }
  }
  unAssign(id) {
    if (this.selectedAssignedList.includes(id)) {
      this.selectedAssignedList.splice(this.selectedAssignedList.indexOf(id), 1);
    } else {
      this.selectedAssignedList.push(id);
    }
  }
  selectAllRemaining() {
    if (this.selectedRemaingList.length > 0) {
      this.selectedRemaingList = [];
    } else {
      this.selectedRemaingList = [];
      this.getRemaingList.forEach((data) => {
        this.selectedRemaingList.push(data.id);
      });
    }
  }
  selectAllAssigned() {
    if (this.selectedAssignedList.length > 0) {
      this.selectedAssignedList = [];
    } else {
      this.selectedAssignedList = [];
      this.getAssignedList.forEach((data) => {
        this.selectedAssignedList.push(data.id);
      });
    }
  }
  assignRequest() {
    if (this.selectedRemaingList.length > 0) {
      this.loading = true;
      let send = {
        cmpTypeId: this.selectedCompanyType,
        docTypeId: this.selectedRemaingList,
        lkupTable: this.refernceTable,
        lkupCol: this.lkupCol,
        action: 'link'
      };
      this.gridService.relate(send).subscribe({
        next: (data) => {
          this.selectedRemaingList = [];
          this.selectedAssignedList = [];
          this.refreshLists();
          LogService.emitAlert({
            type: 'success',
            body: data.message,
          });
        },
        error: (error) => {
          this.loading = false;
          this.logger.error(error);
        },
      });
    }
  }
  unAssignRequest() {
    if (this.selectedAssignedList.length > 0) {
      this.loading = true;
      let send = {
        cmpTypeId: this.selectedCompanyType,
        docTypeId: this.selectedAssignedList,
        lkupTable: this.refernceTable,
        lkupCol: this.lkupCol,
        action: 'unlink'
      };
      this.gridService.relate(send).subscribe({
        next: (data) => {
          this.selectedRemaingList = [];
          this.selectedAssignedList = [];
          this.refreshLists();
          LogService.emitAlert({
            type: 'success',
            body: data.message,
          });
        },
        error: (error) => {
          this.loading = false;
          this.logger.error(error);
        },
      });
    }
  }
  refreshLists() {
    this.loading = true;

    this.getRemainingParams = {
      val: this.selectedCompanyType,
      lkupCol: this.lkupCol,
      lkupTable: this.lkupTable,
      referenceTable: this.refernceTable,
      langId: this.langId,
    };

    this.getAssignedParams = {
      val: this.selectedCompanyType,
      lkupCol: this.lkupCol,
      lkupTable: this.lkupTable,
      referenceTable: this.refernceTable,
      langId: this.langId,
    };

    forkJoin([
      this.gridService.getRemaining(this.getRemainingParams),
      this.gridService.getAssigned(this.getAssignedParams),
    ]).subscribe({
      next: ([remaingList, assignedList]) => {
        this.getRemaingList = remaingList.data;
        this.getAssignedList = assignedList.data;
        this.loading = false;
      },
    }),
      (error) => {
        this.logger.error(error);
        this.loading = false;
      };
  }
}
